import { render, staticRenderFns } from "./ImportProductsDialogWidget.vue?vue&type=template&id=2e222c9c&"
import script from "./ImportProductsDialogWidget.vue?vue&type=script&lang=js&"
export * from "./ImportProductsDialogWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports